import { CreateDataSource_Body, IDataSource, UpdateDataSource_Body, createDataSource, deleteDataSources, getAllDataSources, updateDataSources } from '@/services/data-source-service';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState: DataSourceSliceDataType = {
  loading: false,
  allDataSources: [],
  workflowDataSources: [],
};

const dataSourceSlice = createSlice({
  name: 'dataSource',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDataSourceThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDataSourceThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.allDataSources = Array.isArray(action.payload) ? action.payload : [];
      state.workflowDataSources = state.allDataSources.filter((item) => item.workflowConfig?.isEnabled);
    });
    builder.addCase(createDataSourceThunk.fulfilled, (state, action) => {
      if (action.payload === null) return;
      state.allDataSources = [...state.allDataSources, action.payload];
      state.workflowDataSources = state.allDataSources.filter((item) => item.workflowConfig?.isEnabled);
    });
    builder.addCase(updateDataSourceThunk.fulfilled, (state, action) => {
      if (action.payload === null) return;
      state.allDataSources = state.allDataSources.map((item) => (item._id === action.payload?._id ? action.payload : item));
      state.workflowDataSources = state.allDataSources.filter((item) => item.workflowConfig?.isEnabled);
    });
    builder.addCase(deleteDataSourceThunk.fulfilled, (state, action) => {
      if (action.payload === null) return;
      state.allDataSources = state.allDataSources.filter((item) => item._id !== action.payload?._id);
      state.workflowDataSources = state.allDataSources.filter((item) => item.workflowConfig?.isEnabled);
    });
  },
});

export default dataSourceSlice.reducer;
export interface DataSourceSliceDataType {
  loading: boolean;
  allDataSources: IDataSource[];
  workflowDataSources: IDataSource[];
}

export const getDataSourceThunk = createAsyncThunk('dataSource/getDataSourceThunk', async () => {
  const response = await getAllDataSources();
  return response.data || [];
});

export const createDataSourceThunk = createAsyncThunk('dataSource/createDataSourceThunk', async (newDataSourceData: CreateDataSource_Body) => {
  const response = await createDataSource(newDataSourceData);
  //@ts-ignore
  return response.data.data.data;
});

export const updateDataSourceThunk = createAsyncThunk('dataSource/updateDataSourceThunk', async ({ id, newData }: { id: IDataSource['_id']; newData: UpdateDataSource_Body }) => {
  const response = await updateDataSources({ _id: id }, newData);
  //@ts-ignore
  return response.data.data.data;
});

export const deleteDataSourceThunk = createAsyncThunk('dataSource/deleteDataSourceThunk', async (id: IDataSource['_id']) => {
  const response = await deleteDataSources({ _id: id });
  return response.data.data;
});
